import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiActivity, FiUsers, FiBookOpen } = FiIcons;

const features = [
  {
    icon: FiActivity,
    title: 'Movement Science Foundations',
    text: 'Look for coursework covering anatomy, physiology, kinesiology, therapeutic exercise, mobility, safety, and patient-centered care.',
  },
  {
    icon: FiUsers,
    title: 'Supervised Clinical Education',
    text: 'Clinical rotations help students practice communication, transfers, documentation, treatment support, and safe patient handling under supervision.',
  },
  {
    icon: FiBookOpen,
    title: 'Licensure Preparation',
    text: 'Compare how each program supports graduation, National Physical Therapy Examination preparation, Texas licensure, and entry into the profession.',
  },
];

function FeatureGrid() {
  return (
    <section className="choose-section">
      <div className="section contained">
        <div className="section-heading">
          <p className="eyebrow">What to look for</p>
          <h2>Choose PTA Training That Builds Patient-Care Confidence</h2>
          <p>
            Strong physical therapist assistant education connects classroom knowledge
            with laboratory practice and supervised clinical experience. Compare the
            curriculum, faculty support, clinical sites, schedule, total cost, and
            licensure preparation before choosing a program.
          </p>
        </div>

        <div className="feature-grid">
          {features.map((feature, index) => (
            <article className={`feature-card feature-${index + 1}`} key={feature.title}>
              <SafeIcon icon={feature.icon} />
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeatureGrid;